import LocalImages from "assets/images/local-images";
import Content, { ContentNS } from "content/content";
import useMultiPaxSession from "features/shared/hooks/useMultiPaxSession";
import { MicroHeader } from "features/shared/styles/typography/MicroHeader.styled";
import { TertiaryHeader } from "features/shared/styles/typography/TertiaryHeader.styled";
import Journey from "models/journey/journey";
import TransitPoint from "models/journey/transit-point";
import { FC } from "react";
import { capitalize } from "utils";

// @ts-expect-error - This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
// See configuration in webpack.config.js
import Airport from "./styles/Airport-APP_CLIENT.styled";
import FlightIcon from "./styles/FlightIcon.styled";
// @ts-expect-error: This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
import FlightInfoContainer from "./styles/FlightInfoContainer-APP_CLIENT.styled";
// @ts-expect-error - This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
import FlightRoute from "./styles/FlightRoute-APP_CLIENT.styled";
// @ts-expect-error: This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
import FlightTime from "./styles/FlightTime-APP_CLIENT.styled";
// @ts-expect-error: This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
import Transit from "./styles/Transit-APP_CLIENT.styled";
import { isValidDate } from "./utils/date-validation";
import { Summary } from "features/shared/styles/typography/Summary.styled";

interface FlightProps {
  flight: Journey;
}

const TravelTime: FC<{ departureDate: Date }> = ({ departureDate }) => {
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    weekday: "long",
  };

  const travelTime = isValidDate(departureDate)
    ? Content.shared.t("trip-date", {
        val: departureDate,
        formatParams: { val: options },
        ns: ContentNS.ui,
      })
    : "";

  return (
    <div>
      {travelTime.split(" ").map((word: string, index: number) => {
        return (
          <span key={`${word}_${index}_container`}>
            <span key={`${word}_${index}`}>{word}</span>
            {!(word[0] === "," || word[word.length - 1] === ",") ? (
              <>&nbsp;</>
            ) : (
              " "
            )}
          </span>
        );
      })}
    </div>
  );
};

const FlightInfo: FC<FlightProps> = ({ flight }) => {
  const isMultiPax = useMultiPaxSession();

  const stops = flight.transit
    .map((stop: TransitPoint) => capitalize(stop.airportCode, true))
    .join(", ");

  const planeIcon = LocalImages.shared.images?.icons.plane || "";
  const departureDate = new Date(flight.departure.departureLocalDatetime);
  const arrivalDate = new Date(flight.arrival.arrivalLocalDatetime);

  const flightTimeOptions = {
    hour: "numeric",
    minute: "numeric",
  };

  const departureTime = isValidDate(departureDate)
    ? Content.shared.t("trip-date", {
        val: departureDate,
        formatParams: { val: flightTimeOptions },
        ns: ContentNS.ui,
      })
    : "";

  const arrivalTime = isValidDate(departureDate)
    ? Content.shared.t("trip-date", {
        val: arrivalDate,
        formatParams: { val: flightTimeOptions },
        ns: ContentNS.ui,
      })
    : "";

  return (
    <FlightInfoContainer data-testid="flight-info" isMultiPax={isMultiPax}>
      <FlightTime>
        <Summary>
          <TravelTime departureDate={departureDate} />
        </Summary>
        {flight.flightNumbers && flight.flightNumbers.length > 0 ? (
          <Summary>{flight.flightNumbers.at(0)}</Summary>
        ) : null}
      </FlightTime>
      <FlightRoute>
        <Airport>
          <TertiaryHeader className="city">{`${flight.departure.airport.code}`}</TertiaryHeader>
          <Summary className="city">{`${departureTime}`}</Summary>
        </Airport>

        <Transit>
          <FlightIcon
            desktopSrc={planeIcon}
            mobileSrc={planeIcon}
            alt="airplane icon"
          />
          <MicroHeader>{stops}</MicroHeader>
        </Transit>
        <Airport>
          <TertiaryHeader className="city">{`${flight.arrival.airport.code}`}</TertiaryHeader>
          <Summary className="city">{`${arrivalTime}`}</Summary>
        </Airport>
      </FlightRoute>
    </FlightInfoContainer>
  );
};

export default FlightInfo;
